import { LAYOUT_LIST, QUIZ_CHOICE, SCROLLABLE_CONTAINER } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { CardHelper } from '~/training/sequence/templates/translators/itemHelpers/CardHelper';
import { ItemOfType } from '~/training/sequence/templates/translators/itemHelpers/types';
import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import { detectMultiSelect } from '~/training/sequence/templates/translators/itemHelpers/Quiz';
import { useEditorStore } from '~/shell/Store';

export const Quiz11: Translator = sequence => {
  const { contentEditable } = useEditorStore.getState();
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question': {
        const card = CardHelper(item as ItemOfType<'Question'>, {
          width: { _: '95vw', lg: '50vw' },
          height: 'auto',
          align: 'left',
          padding: '0px',
          extraItems: [
            {
              type: QUIZ_CHOICE,
              id: '1',
              values: {
                variant: item.items && item.items.length > 2 ? 'list' : '',
                title: item?.title?.includes('?')
                  ? item.title
                  : item?.body?.includes('?')
                  ? item.body
                  : '',
                length: item?.items?.length,
                multiSelect: item?.items?.filter(item => item.correct === true)
                  .length
              },
              items: AnswerButtonHelper({
                group: null,
                items: item.items,
                llamaSurvey: item.llamaSurvey,
                question: item.title || '',
                correctAnswers: item.items ? detectMultiSelect(item.items) : []
              })
            }
          ]
        });

        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: contentEditable
            ? [
                {
                  id: `${item.id}_wrapper`,
                  type: SCROLLABLE_CONTAINER,
                  values: {
                    height: '80vh',
                    overflow: 'auto'
                  },
                  items: [card]
                }
              ]
            : [card]
        };
      }
      default:
        return null;
    }
  });
};
